import { featured } from '@/mocks/home';

export default function Featured() {
  return (
    <section id="featured" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="relative w-full aspect-[3/2] rounded-lg overflow-hidden border border-background-200">
              <img
                src={featured.cover}
                alt={`${featured.title} 专题封面，展示现场舞台多机位视角`}
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-accent-500 text-background-50 text-xs md:text-sm font-label">
                <i className="ri-star-smile-line" aria-hidden="true"></i>
                编辑精选
              </span>
            </div>

            <div className="mt-5 grid grid-cols-3 gap-3 md:gap-5">
              {featured.stats.map((s) => (
                <div
                  key={s.label}
                  className="bg-background-100 border border-background-200 rounded-lg px-3 py-4 text-center"
                >
                  <p className="font-heading font-bold text-lg md:text-2xl text-primary-700">{s.value}</p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-sm font-label font-medium text-accent-700">
              <span className="w-6 h-[2px] bg-accent-500" aria-hidden="true"></span>
              {featured.subtitle}
            </span>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              {featured.title}
            </h2>

            <div className="mt-5 space-y-4">
              {featured.paragraphs.map((p, index) => (
                <p key={index} className="text-sm md:text-base leading-relaxed text-foreground-600">
                  {p}
                </p>
              ))}
            </div>

            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {featured.points.map((point) => (
                <li key={point} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-base mt-0.5" aria-hidden="true"></i>
                  {point}
                </li>
              ))}
            </ul>

            <a
              href="#collections"
              className="mt-7 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              查看全部精选合集
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}